import { FormActions } from "../../components/common/FormActions";
import {
  createViewAction,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_DAILY_WAGES_COLLECTIONS } from "../../utils/urls";
import { BooleanTags } from "../../components/common/registerUtils";
import dayjs from "dayjs";

const useDailyCollections = () => {
  const tableColumns = () => [
    {
      id: "user_name",
      header: "User Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "user_email",
      header: "Email",
      filter: {
        type: "text",
      },
    },
    {
      id: "staff_type",
      header: "Staff Type",
      filter: {
        type: "text",
      },
    },
    {
      id: "collection_date",
      header: "Collection Date",
      filter: {
        type: "date",
      },
    },
    {
      id: "parking_payment_amount",
      header: "Parking Amount",
    },
    {
      id: "advance_payment_amount",
      header: "E-Coupon Payment Amount",
    },
    {
      id: "clamped_vehicle_amount",
      header: "Clamped Vehicle Amount",
    },
    {
      id: "total_amount",
      header: "Total Amount",
    },
    {
      id: "is_processed",
      header: "Is Processed",
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        parking_payment_amount: numberFormat(item?.parking_payment_amount),
        advance_payment_amount: numberFormat(item?.advance_payment_amount),
        clamped_vehicle_amount: numberFormat(item?.clamped_vehicle_amount),
        total_amount: numberFormat(item?.total_amount),
        is_processed: <BooleanTags status={item?.is_processed} />,
        created_at: formatDateTime(item?.created_at),
        created_by: `${item?.created_by?.first_name} ${item?.created_by?.last_name}`,
        actions: (
          <FormActions
            actions={[createViewAction(URL_DAILY_WAGES_COLLECTIONS, item?.id)]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Staff Wage Details",
          fields: {
            ...item,
            id: item?.id,
            is_processed: <BooleanTags status={item?.is_processed} />,
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
            created_by: `${item?.created_by?.first_name} ${item?.created_by?.last_name}`,
          },
        },
      ],
    };
  };

  const initialFilters = {
    // start_date: dayjs().format("YYYY-MM-DD"),
    start_date: null,
    end_date: dayjs().format("YYYY-MM-DD"),
  };

  const externalFilters = [
    {
      id: "collection_date",
      label: "Collection Date Range",
      type: "date",
      options: [],
    },
  ];

  const tableTitle = "Daily Collections";
  const activityFilter = "daily_collection";

  return {
    tableColumns,
    tableData,
    initialFilters,
    externalFilters,
    activityFilter,
    tableTitle,
    // tableHeaderItem,
    viewData,
  };
};

export default useDailyCollections;
